import React, { Component } from "react";
import StackedBarChart from "components/charts/StackedBarChart";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const addPropsToSeriesForRace = (series) => {
	var seriesData = [];
	var total = 0;

	for (var race in series) {
		if (series.hasOwnProperty(race)) {
			seriesData.push({
				name: (race == "Asian") ? "Asian and Pacific Islander" : race,
				y: series[race].counts_sum
			});
			total += series[race].counts_sum;
		}
	}

	return { seriesData: seriesData, total: total };
}

const addPropsToSeriesForAge = (data) => {
	const categories = [];
	const males = [];
	const females = [];

	for (let age_group in data) {
		categories.push(age_group);
		females.push(data[age_group]['genders']['Females']['count']);
		males.push(-data[age_group]['genders']['Males']['count']);
	}

	return {
		categories,
		series: [
			{ name: 'Females', data: females, color: '#FF6699' },
			{ name: 'Males', data: males, color: '#3366FF' }
		]
	};
};

class Demographics extends Component {

  	constructor(props) {
		super(props);
		this.state = {
		}
  	}

	render() {

		var processedRaceData = addPropsToSeriesForRace(this.props.raceData);

		const raceOptions = {
			chart: {
				animation: false,
				type: "pie",
				plotBackgroundColor: "transparent",
				backgroundColor: 'transparent',
				height: "400px",
				events: {
					render: function() {
						var total = processedRaceData.total,
							chart = this,
							centerX = chart.plotWidth / 2,
							centerY = (chart.plotHeight / 2) + 40;
			
						var displayText = 'Total number of people';
						
						if (chart.customTextLabel) chart.customTextLabel.destroy();
						if (chart.customTotalLabel) chart.customTotalLabel.destroy();
			
						chart.customTextLabel = chart.renderer.text(displayText, centerX+10, centerY+70)
							.attr({
								'text-anchor': 'middle',
								'font-size': '15px',
								'fill': '#FFF'
							})
							.add();
			
						chart.customTotalLabel = chart.renderer.text(total.toLocaleString(), centerX+10, centerY+100)
							.attr({
								'text-anchor': 'middle',
								'font-size': '15px',
								'font-weight': 'bold',
								'fill': '#FFF'
							})
							.add();
					}
				}
			},
			title: {
				text: "",
				style: {
					color: "#FFF",
					font: "normal normal bold 24px/28px Arial",
				},
			},
			credits: {
				enabled: false,
			},
			exporting: {
				enabled: false,
			},
			plotOptions: {
				pie: {
					dataLabels: {
						enabled: false,
					},
					states: {
						inactive: {
							opacity: 1,
						},
					},
					borderWidth: 0,
					showInLegend: true,
					innerSize: '80%',
					point: {
						events: {
							legendItemClick: function() {
								return false;
							},
						},
					},
				},
				series: {
					animation: false,
				},
			},
			tooltip: {
				backgroundColor: "#FFF",
				borderRadius: 8,
				borderWidth: 1,
				padding: 14,
				style: {
					color: "#333333",
					fontSize: "14px",
					fontFamily: "Arial",
				},
				headerFormat: '',
				pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>'
			},
			legend: {
				itemStyle: {
					color: "#FFF",
					font: "normal normal normal 18px Arial",
				},
				verticalAlign: "top",
				align: "center",
				backgroundColor: "transparent",
				padding: 20,
				itemMarginTop: 5,
				itemMarginBottom: 10,
				symbolRadius: 0,
				width: "100%",
			},
			series: [{
				name: 'Races',
				colorByPoint: true,
				data: processedRaceData.seriesData.sort(function(a, b) {
					const order = ["American Indian", "Hispanic", "Asian and Pacific Islander",  "African American", "Two or More Races", "White"];
					return order.indexOf(a.name) - order.indexOf(b.name);
				})
			}],
			colors: [  
				"#DE3E40", // American Indian
				"#6AA4DC", // Hispanic
				"#FB6A59", // Asian and Pacific Islander
				"#FFB607", // African American
				"#70898E", // Two or More Races
    			"#005898", // White   
			]
		}

		var processedAgeData = addPropsToSeriesForAge(this.props.ageData)
		var originalData = this.props.ageData

		const ageOptions = {
            chart: {
                animation: false,
                type: 'bar',
                plotBackgroundColor: "transparent",
				backgroundColor: 'transparent',
                height: 390,
                width: 900,
                spacingTop: 0,
                dataLabels: false,
            },
            plotOptions: {
				series: {
					stacking: 'normal',
					animation: false,
					groupPadding: 0.15,
					pointPadding: 1,
					pointWidth: 25,
					borderWidth: 0 
				}
			},
            series: [
				{
					name: 'Males',
					data: processedAgeData.series[1].data,  
					color: '#6AA4DC'
				},
				{
					name: 'Females',
					data: processedAgeData.series[0].data,  
					color: '#FB6A59'
				}
			],
            xAxis: {
                scrollbar: {
                    enabled: true
                },
                categories: processedAgeData.categories,
                title: {
                    text: null
                },
                labels: {
                    useHTML: true, 
                    formatter: function() {
                        return `<div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; width: 150px; color: #fff; font: normal normal normal 13px Arial;padding-left: 30px;z-index: 1;">
                                    ${this.value}
                                </div>`;
                    }
                },
                align: 'left'
            },
            yAxis: {
                scrollbar: {
                    enabled: true
                },
                offset: 10,
                title: {
                    text: "Gender Distribution by Age",
                    style: {
                        color: "#fff",
                        font: "normal normal normal 18px Arial",
                        letterSpacing: "0.49px"
                    }
                },
                labels: {
                    overflow: "justify",
                    style: {
                        color: "#fff",
                        font: "normal normal normal 18px Arial"
                    },
					formatter: function() {
						let value = Math.abs(this.value);
						if (value >= 1000) {
							value = (value / 1000) + 'K';
						}
						return value;
					},
                },
                gridLineWidth: 0.5
            },
            exporting: { enabled: false },
            title: null,
            legend: {
                reversed: false,
                itemStyle: {
                    color: "#FFF",
                    font: "normal normal normal 16px/27px Arial"
                },
                verticalAlign: "top",
                align: "left",
                x: 80,
                backgroundColor: "transparent",
                padding: 20,
                itemMarginTop: 5,
                itemMarginBottom: 10,
                symbolRadius: 0,
                symbolHeight: 10,
                symbolWidth: 10
            },
            credits: {
                enabled: false
            },
            tooltip: {
				borderRadius: 15,
				borderWidth: 1,
				borderColor: "#707070",
				backgroundColor: "#FFFFFF",
				padding: 17,
				shape: "square",
				style : {
					font: "Arial",
					fontSize: "14px",
					color: "#333333",
					lineHeight: 25,
					zIndex: 999, 
				},
                formatter: function() {
					const age_group = this.point.category;
					const gender = this.series.name;
					const count = Math.abs(this.point.y).toLocaleString();  // Format count as locale string
					const age_percent = originalData[age_group]['age_percent'];
					const gender_percent = originalData[age_group]['genders'][gender]['gender_percent'];
					return `
						Age: <b>${age_group}</b><br>
						Gender: <b>${gender}</b><br>
						Count: <b>${count}</b><br>
						Age%: <b>${age_percent}%</b><br>
						Gender%: <b>${gender_percent}%</b>`;
				}				
            }
        };

		return (
			<div className="graph-wrapper screen-right-graph-container">
				<div className="graph-title-container" >
					<div className="graph-title">Regional population by race/ethnicity and age</div>
				</div>
				
				<div className="outcome-race-graph">
				{ this.props.raceData ? 
					<HighchartsReact highcharts={Highcharts} options={raceOptions} />
				
					: "No data available" 
				}
				</div>
				<div className="outcome-age-graph">
				{ this.props.ageData ? 
					<HighchartsReact highcharts={Highcharts} options={ageOptions} />
				
					: "No data available" 
				}
				</div>
			</div>
		);
	}
}

export default Demographics;
